import { Grid, Typography } from '@material-ui/core'
import AutorenewIcon from '@material-ui/icons/Autorenew'
import React from 'react'
import styled from 'styled-components'

import { autoShipIntervalOptions } from '../../../lib/cart/item-control-options'

const StyledAutorenewIcon = styled(AutorenewIcon)`
  margin-right: 5px;
  vertical-align: middle;
`

const orderFrequencyLabel = ({
  autoShipInterval = 1,
}: {
  autoShipInterval: number | null | undefined
}): string | undefined => {
  const stringValue = `${autoShipInterval == null ? 1 : autoShipInterval}`
  const chosenOption = autoShipIntervalOptions.find(
    (orderFrequencyOption) => orderFrequencyOption.value === stringValue,
  )

  return chosenOption ? `Auto-Ship every ${chosenOption.label}` : undefined
}

export interface OrderTypeSummaryProps {
  autoShipInterval: number | null | undefined
  className?: string
  orderType: number | null | undefined
}

const OrderTypeSummary: React.FC<OrderTypeSummaryProps> = ({
  autoShipInterval,
  className,
  orderType,
}) => {
  if (orderType !== 2) {
    return null
  }

  return (
    <Grid className={className} item>
      <StyledAutorenewIcon color="primary" fontSize="small" />
      <Typography variant="caption">{orderFrequencyLabel({ autoShipInterval })}</Typography>
    </Grid>
  )
}

const StyledOrderTypeSummary = styled(OrderTypeSummary)`
  font-style: italic;
  margin-bottom: 10px;
`

export default StyledOrderTypeSummary
